import { Component, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { EMPTY, Observable } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { WorkblockService } from '../../../services/workblock.service';
import { taskTypeActionFeatures } from '../ActionWorkspace/TaskTypeActionFeatures';
import { WorkblockFilePickerComponent } from './workblock-file-picker.component';
import TaskWorkblockRequest = Boo.Workblocks.Models.TaskWorkblockRequest;
import TaskTypeWorkblockRequest = Boo.Workblocks.Models.TaskTypeWorkblockRequest;
import Reasons = Boo.Workblocks.Models.WorkblockReason;

export enum Filters {
  UpcomingTickets = 'Upcoming Tickets',
  All = 'All',
  Appointments = 'Appointments',
  WorkStoppage = 'Work Stoppage'
}

@Component({
  selector: 'app-components-specialist-workblocktask',
  templateUrl: './workblock-task.component.html'
})
export class WorkblockTaskComponent implements OnInit {
  @Input() action: Boo.Objects.Action;
  @Input() reason: UntypedFormControl;
  @Input() note: UntypedFormControl;
  @Output() public saved: EventEmitter<any> = new EventEmitter<any>();
  @Output() public canceled: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('filePicker') filePicker: WorkblockFilePickerComponent;

  maxWorkblockFiles = 3;
  workblockThisTaskType = false;
  isLoading = false;
  reasons: Reasons[];
  canWorkblockTaskType: boolean;

  constructor(
    private workblockService: WorkblockService) { }

  ngOnInit(): void {
    this.reason.addValidators(Validators.required);
    this.note.addValidators(Validators.required);
    this.workblockService.getReasons().subscribe(x => this.reasons = x);
    this.canWorkblockTaskType = !taskTypeActionFeatures.canNotWorkblockTaskType.includes( this.action.Task.TaskTypeEnum);
  }

  public cancel(): void {
    this.clearForm();
    this.canceled.emit();
  }

  public save(): void {
    this.note.markAsTouched();
    this.reason.markAsTouched();
    if (this.note.invalid || this.reason.invalid) {
      return;
    }

    this.isLoading = true;

    this.filePicker.uploadAll()
      .pipe(
        catchError(() => {
          toastr.error('Unable to upload one or more files.');
          return EMPTY;
        }),
        switchMap((fileUrls) => {
          let $workblock: Observable<any>;
          if (this.workblockThisTaskType) {
            const taskTypeWorkblockRequest: TaskTypeWorkblockRequest = {
              CustomerId: this.action.Task.CustomerId,
              Note: this.note.value,
              TaskTypeEnum: this.action.Task.TaskTypeEnum,
              OriginationTaskId: this.action.Task.TaskId,
              WorkblockReasonId: this.reason.value,
              S3Urls: fileUrls
            };
            $workblock = this.workblockService.workblockTaskType(taskTypeWorkblockRequest);
          } else {
            const taskWorkblockRequest: TaskWorkblockRequest = {
              CustomerId: this.action.Task.CustomerId,
              Note: this.note.value,
              TaskTypeEnum: this.action.Task.TaskTypeEnum,
              TaskId: this.action.Task.TaskId,
              WorkblockReasonId: this.reason.value,
              S3Urls: fileUrls
            };
            $workblock = this.workblockService.workblockTask(taskWorkblockRequest);
          }

          return $workblock;
        }),
        finalize(() => this.isLoading = false))
      .subscribe(
        () => {
          toastr.success('Task was unlocked and unassigned and Resolve Action Workblock Ticket was created.');
          this.clearForm();
          this.saved.emit();
        },
        (err) => toastr.error(err));
  }

  private clearForm(): void {
    this.note.markAsUntouched();
    this.reason.markAsUntouched();
    this.workblockThisTaskType = false;
    this.filePicker.reset();
  }
}
